import React, { useState, useEffect, useContext } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import StoreFormComp from '../../components/version-4/MasterForms/StoreFormComp'
import { useStore } from '../../hooks/CompanyConfiguration/useStore'
import { useLocation } from '../../hooks/Location/useLocation'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useRegion } from '../../hooks/CompanyConfiguration/useRegion'
import { sortByName } from '../../shared/constants'
import { ROUTES } from '../../shared/constants'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'

export default function StoreForm({ store }) {
  const { addStore, updateStore, loading } = useStore()
  const [address, setAddress] = useState('')
  const [coordinates, setCoordinates] = useState('')
  const [error, setError] = useState(false)

  const [storeData, setStoreData] = useState({
    name: '',
    region: '',
    zone: '',
    state: '',
    district: '',
    city: '',
    area: '',
    email: '',
    mobile: '',
    storeCode: '',
    pinCode: '',
    gst: '',
    startDate: new Date().toISOString(),
    //active: '',
  })

  useEffect(() => {
    if (store) {
      setStoreData({
        name: store.name,
        region: store.region && store.region._id,
        zone: store.zone && store.zone._id,
        state: store.state && store.state._id,
        district: store.district && store.district._id,
        city: store.city && store.city._id,
        area: store.area && store.area._id,
        email: store.email,
        mobile: store.phoneNumber,
        storeCode: store.storeCode,
        pinCode: store.pinCode,
        gst: store.gst,
        active: store.active,
        startDate: new Date(store.startDate),
      })
      setAddress(store.address)
      setCoordinates(store.coordinates)
    }
  }, [store])

  const { getAllRegion } = useRegion()
  const { regions } = useContext(ConfigurationContext)

  const { zones, getAllZone, getAllState, states, districts, getAllDistrict, getAllCity, city, areas, getAllArea } = useLocation()

  useEffect(() => {
    getAllRegion()
  }, [])

  useEffect(() => {
    if (storeData.region) {
      getAllZone({ region: storeData.region })
    }
    if (storeData.zone) {
      getAllState({ region: storeData.region, zone: storeData.zone })
    }
    if (storeData.state) {
      getAllDistrict({ region: storeData.region, zone: storeData.zone, state: storeData.state })
    }
    if (storeData.district) {
      getAllCity({ region: storeData.region, zone: storeData.zone, state: storeData.state, district: storeData.district })
    }
    if (storeData.city) {
      getAllArea({ region: storeData.region, zone: storeData.zone, state: storeData.state, district: storeData.district, city: storeData.city })
    }
  }, [storeData])

  const data = [
    { label: 'Store Code', value: storeData.storeCode, name: 'storeCode' },
    { label: 'Name', value: storeData.name, name: 'name' },
    { label: 'Region', value: storeData.region, name: 'region', options: sortByName(regions), fieldName: 'name', fieldValue: '_id' },
    { label: 'Zone', value: storeData.zone, name: 'zone', options: sortByName(zones), fieldName: 'name', fieldValue: '_id' },
    { label: 'State', value: storeData.state, name: 'state', options: sortByName(states), fieldName: 'name', fieldValue: '_id' },
    { label: 'District', value: storeData.district, name: 'district', options: sortByName(districts), fieldName: 'name', fieldValue: '_id' },
    { label: 'City', value: storeData.cityNew, name: 'city', options: sortByName(city), fieldName: 'name', fieldValue: '_id' },
    { label: 'Area', value: storeData.area, name: 'area', options: sortByName(areas), fieldName: 'name', fieldValue: '_id' },
    { label: 'Email', value: storeData.email, name: 'email', conditions: [{ type: 'EMAIL' }] },
    { label: 'Mobile', value: storeData.mobile, name: 'mobile', conditions: [{ type: 'PHONE' }] },
    { label: 'Pin Code', value: storeData.pinCode, name: 'pinCode' },
    { label: 'GST', value: storeData.gst, name: 'gst' },
    { label: 'Business Start Date', value: storeData.startDate, name: 'startDate', type: 'DATE', maxDate: new Date() },
    { label: 'Address', value: address, name: 'address', type: 'ADDRESS' },
    //{ type: 'ACTIVE' }
  ]

  const handleAddStore = () => {
    if (store) {
      updateStore({
        ...storeData,
        storeId: store._id,
        address,
        startDate: storeData.startDate && storeData.startDate,
        coordinates,
      })
    } else {
      addStore({
        ...storeData,
        address,
        startDate: storeData.startDate && storeData.startDate,
        coordinates,
      })
    }
  }

  return (
    <Layout heading="Store" heading2={store ? 'Edit' : 'Add'} url1={ROUTES.STORE} none>
      <HeaderTabLayout
        heading={`${store ? storeData.name : 'Add Store'}`}
        content={
          <CustomAddForm
            state={storeData}
            setState={setStoreData}
            address={address}
            setAddress={setAddress}
            setCoordinates={setCoordinates}
            edit={store ? true : false}
            data={data}
            setError={setError}
          />
        }
        addContent={handleAddStore}
        redirect={ROUTES.STORE}
        loading={loading}
        state={storeData}
        setState={setStoreData}
        buttonDisabled={error}
      />
    </Layout>
  )
}
